import { gql } from "@apollo/client";

export const CREATE_FINANCE_TREE_TRANSACTION = gql`
  mutation CreateFinanceTreeTransaction($createFinanceTreeTransactionDto: CreateFinanceTreeTransactionDto!) {
    createFinanceTreeTransaction(createFinanceTreeTransactionDto: $createFinanceTreeTransactionDto) {
      id
      transactionNumber
      date
      description
      imageId
      totalDebit
      totalCredit
      isBalanced
      createdAt
      updatedAt
    }
  }
`;

export const UPDATE_FINANCE_TREE_TRANSACTION = gql`
  mutation UpdateFinanceTreeTransaction(
    $id: Int!
    $updateFinanceTreeTransactionDto: UpdateFinanceTreeTransactionDto!
  ) {
    updateFinanceTreeTransaction(
      id: $id
      updateFinanceTreeTransactionDto: $updateFinanceTreeTransactionDto
    ) {
      id
      transactionNumber
      date
      description
      imageId
      totalDebit
      totalCredit
      total
      isBalanced
      createdAt
      updatedAt
      image {
        id
        url
        originalName
        fileName
        mimeType
        type
        size
      }
      transactionLines {
        id
        financeTreeId
        description
        debit
        credit
      }
    }
  }
`;

